document.addEventListener("DOMContentLoaded", function () {
    console.log("JavaScript Loaded!");

    // Function to open modal
    function openModal(modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = "block";
        modal.setAttribute("aria-hidden", "false");
      }
    }

    // Function to close modal
    function closeModal(modal) {
      if (modal) {
        modal.style.display = "none";
        modal.setAttribute("aria-hidden", "true");
      }
    }

    // Add event listeners for "CHOOSE OPTIONS" buttons
    document.querySelectorAll(".choose-options-btn").forEach(button => {
      button.addEventListener("click", function () {
        const productId = this.getAttribute("data-product-id");
        const modalId = `QuickAddModal-${productId}`;
        openModal(modalId);
      });
    });

    // Add event listeners for close buttons inside modals
    document.querySelectorAll(".close-modal-btn").forEach(button => {
      button.addEventListener("click", function () {
        const modal = this.closest(".quick-add-modal");
        closeModal(modal);
      });
    });

    // Close modal when clicking outside of it
    document.querySelectorAll(".quick-add-modal").forEach(modal => {
      modal.addEventListener("click", function (event) {
        if (event.target === modal) {
          closeModal(modal);
        }
      });
    });
  });